import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import { preloadEmojiTitle } from '@confluence/emoji-title/entry-points/preloadEmojiTitle.ts';
import { preloadEditorPageCoverPicture } from '@confluence/page-cover-picture/entry-points/preloadEditorPageCoverPicture.ts';

import SmartCreatePageEditorDataWrapperComponentQuery from './__generated__/SmartCreatePageEditorDataWrapperComponentQuery.graphql.ts';
import type {
	SmartCreatePageEditorDataWrapperComponentQuery$data,
	SmartCreatePageEditorDataWrapperComponentQuery$variables,
} from './__generated__/SmartCreatePageEditorDataWrapperComponentQuery.graphql.ts';

const preloadEditorData = async (contentId: string) => {
	return query<
		SmartCreatePageEditorDataWrapperComponentQuery$data,
		SmartCreatePageEditorDataWrapperComponentQuery$variables
	>({
		query: SmartCreatePageEditorDataWrapperComponentQuery,
		variables: {
			contentId,
		},
	});
};

export const preloadSmartCreateEditorData = async (contentId: string) => {
	return waitForAllReturnWhenError([
		preloadEditorData(contentId),
		preloadEmojiTitle(contentId, '', false),
		preloadEditorPageCoverPicture(contentId, '', false),
	]);
};
